import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { NotifPrefs } from '../domain/notif-prefs.model';
import { initialState } from './notification-preferences.state';

/**
 * Notification-preferences slice. Pure state transitions only; persistence
 * lives in the saga. `toggled` updates one channel optimistically (the saga then
 * saves the full prefs); `loaded` hydrates from the gateway on mount.
 */
const slice = createSlice({
  name: 'notificationPreferences',
  initialState,
  reducers: {
    loaded: (state, action: PayloadAction<NotifPrefs>) => {
      state.prefs = action.payload;
    },
    toggled: (state, action: PayloadAction<{ key: keyof NotifPrefs; value: boolean }>) => {
      state.prefs[action.payload.key] = action.payload.value;
    },
    resetPrefs: () => initialState,
  },
});

export const notificationPreferencesActions = slice.actions;
export const notificationPreferencesReducer = slice.reducer;
